import { lazy, Suspense } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import ScrollProgress from "@/components/ScrollProgress";

const ProblemSection = lazy(() => import("@/components/ProblemSection"));
const CostOfNotKnowing = lazy(() => import("@/components/CostOfNotKnowing"));
const HowItWorks = lazy(() => import("@/components/HowItWorks"));
const HumanJoin = lazy(() => import("@/components/HumanJoin"));
const CostOfInaction = lazy(() => import("@/components/CostOfInaction"));
const SetupSection = lazy(() => import("@/components/SetupSection"));
const ICPCallout = lazy(() => import("@/components/ICPCallout"));
const FAQ = lazy(() => import("@/components/FAQ"));
const CTASection = lazy(() => import("@/components/CTASection"));
const Footer = lazy(() => import("@/components/Footer"));

const Index = () => {
  return (
    <main className="overflow-x-hidden">
      <ScrollProgress />
      <Navbar />
      <Hero />
      <Suspense fallback={null}>
        <ProblemSection />
        <HowItWorks />
        <HumanJoin />
        <CostOfNotKnowing />
        <CostOfInaction />
        <SetupSection />
        <ICPCallout />
        <FAQ />
        <CTASection />
        <Footer />
      </Suspense>
    </main>
  );
};

export default Index;
